
<div class="row mb-4">
  <div class="col-10">
    <h3 mat-dialog-title  >
      {{ 'ComparetoOtherProviders' | translate }}
    </h3>
  </div>
  <div class="col-2 p-0">
      <button mat-dialog-action class="btnLink closeModal text-right" (click)="close()"> <fa-icon [icon]="faTimesCircle"></fa-icon></button>
  </div>
</div>

<mat-dialog-content>
<div class="row">
  <!-- Rank -->
  <div class="col-md-12">
    <div class="car-rank mr-2 mb-3"><span class="badge badge-pill badge-primary">{{evaluationSummary.average}}</span> {{evaluationSummary.resourceName}}</div>
  </div>

  <ng-container *ngIf="evaluationSummary!=null">
    <div *ngFor="let review of evaluationSummary.evaluationLogsDetails" class="col-md-6">
      <div class="slideContainer">
        <div class="d-flex">
          <div class="mr-auto slideCriteria">{{review.description}}</div>
          <!-- <div class="slideValue badge badge-pill badge-primary">{{review.average}}</div> -->
        </div>
        <mat-slider disabled class="mb-2" min="0" max="10" [value]="review.average"></mat-slider>
      </div>
    </div>
  </ng-container>

</div>
</mat-dialog-content>

